export const ALERT_TYPES = {
  SUCCESS: 'ALERT_SUCCESS',
  INFO: 'ALERT_INFO',
  ERROR: 'ALERT_ERROR',
  CLEAR: 'ALERT_CLEAR',
};
